const QR_RENDER_OPTIONS = { margin: 1, width: 240, errorCorrectionLevel: 'M' };

export function renderQrDataUrl(payload) {
  return import('qrcode/lib/browser').then((qrcode) =>
    qrcode.toDataURL(payload, QR_RENDER_OPTIONS)
  );
}

export default renderQrDataUrl;
